import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'plannedStatus',
    'nurseryVisible',
    'primaryVisible',
    'foodAllergiesVisible',
    'foodAllergiesStatus',
    'allergenicFoodsOptions',
    'otherFoodNameVisible',
    'nonFoodAllergiesVisible',
    'nonFoodAllergiesStatus',
    'symptomsVisible',
    'foodrequestVisible',
    'allergyEliminationVisible',
    'foodrequestYesOrNoStatus',
    'diagnosisVisible',
    'developmentaldisorderStatus',
    'medicalHistoryVisible',
    'medicalHistoryStatus',
  ]

  switchPlannedParticipation(e) {
    this.nurseryVisibleTargets.forEach((element) => {
      element.classList.toggle('hidden', this.plannedStatusTarget.value === 'elementary')
    })
    this.primaryVisibleTargets.forEach((element) => {
      element.classList.toggle('hidden', this.plannedStatusTarget.value === 'daycare')
    })
  }

  handleSwitchFields(e) {
    this.foodAllergiesStatusTargets.forEach((element) => {
      if (element.checked) {
        this.foodAllergiesVisibleTarget.classList.toggle('hidden', element.value === 'no_answer')
        this.symptomsVisibleTarget.classList.toggle('hidden', element.value === 'no_answer')
        this.allergyEliminationVisibleTarget.classList.toggle('hidden', element.value === 'no_answer')
        this.nonFoodAllergiesStatusTargets.forEach((nonFoodAllergiesStatus) => {
          if (nonFoodAllergiesStatus.checked && nonFoodAllergiesStatus.value === 'yes_answer') {
            this.symptomsVisibleTarget.classList.remove('hidden')
          }
        })
      }
    })

    this.nonFoodAllergiesStatusTargets.forEach((element) => {
      if (element.checked) {
        this.nonFoodAllergiesVisibleTarget.classList.toggle('hidden', element.value === 'no_answer')
        this.symptomsVisibleTarget.classList.toggle('hidden', element.value === 'no_answer')
        this.foodAllergiesStatusTargets.forEach((foodAllergiesStatus) => {
          if (foodAllergiesStatus.checked && foodAllergiesStatus.value === 'yes_answer') {
            this.symptomsVisibleTarget.classList.remove('hidden')
          }
        })
      }
    })

    this.foodrequestYesOrNoStatusTargets.forEach((element) => {
      if (element.checked) {
        this.foodrequestVisibleTarget.classList.toggle('hidden', element.value === 'no_answer')
        this.foodAllergiesStatusTargets.forEach((foodAllergiesStatus) => {
          if (foodAllergiesStatus.checked) {
            this.allergyEliminationVisibleTarget.classList.toggle(
              'hidden',
              element.value === 'no_answer' && foodAllergiesStatus.value === 'no_answer',
            )
          }
        })
      }
    })

    this.allergenicFoodsOptionsTargets.forEach((element) => {
      if (element.value === 'others' && element.checked) {
        this.otherFoodNameVisibleTarget.classList.remove('hidden')
      } else {
        this.otherFoodNameVisibleTarget.classList.add('hidden')
      }
    })

    this.developmentaldisorderStatusTargets.forEach((element) => {
      if (element.checked) {
        this.diagnosisVisibleTarget.classList.toggle('hidden', element.value === 'no_answer')
      }
    })

    this.medicalHistoryStatusTargets.forEach((element) => {
      if (element.checked) {
        this.medicalHistoryVisibleTarget.classList.toggle('hidden', element.value === 'no_answer')
      }
    })
  }
}
